export default __webpack_public_path__ + "static/media/img-1.1cbc50f5.png";